import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './send-confirm.component.html',
  styleUrls: ['./send-confirm.component.css']
})
export class SendConfirmComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/send-confirm/send-confirm.component.ts